import { Button, Modal, Message, Panel, List, Divider } from "rsuite";

interface NoteModalProps {
    open: boolean;
    setOpen: (open: boolean) => void;
}

export default function NoteModal({ open, setOpen }: NoteModalProps) {
    const onClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Modal backdrop={true} keyboard={false} open={open} onClose={onClose} size="sm">
                <Modal.Header>
                    <Modal.Title>Guia de Importação</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ display: "grid", gap: 12, marginRight: '1rem' }}>
                        <Message type="info" showIcon>
                            Utilize estas orientações para preparar corretamente suas planilhas de importação.
                        </Message>

                        <Panel bordered header="Importação de Clientes/Fornecedores">
                            <Message type="warning" showIcon>
                                <strong>Campos obrigatórios Omie — para conclusão da importação:</strong>
                                <List bordered size="sm" style={{ marginTop: 8, wordBreak: "break-word" }}>
                                    <List.Item>Nome / Razão Social</List.Item>
                                    <List.Item>CPF / CNPJ</List.Item>
                                    <List.Item>Tipo (Pessoa Física ou Jurídica)</List.Item>
                                </List>
                            </Message>
                        </Panel>

                        <Panel bordered header="Importação de Títulos">
                            <Message type="warning" showIcon>
                                <strong>Campos obrigatórios Omie — para conclusão da importação:</strong>
                                <List bordered size="sm" style={{ marginTop: 8, wordBreak: "break-word" }}>
                                    <List.Item>Data de Emissão</List.Item>
                                    <List.Item>Data de Vencimento</List.Item>
                                    <List.Item>CPF / CNPJ</List.Item>
                                    <List.Item>Tipo</List.Item>
                                    <List.Item>Valor Bruto</List.Item>
                                    <List.Item>
                                        Se houver parcelamento, informar o <em>número total</em> de parcelas.
                                    </List.Item>
                                </List>
                            </Message>

                            <Divider />

                            <Message type="info" showIcon>
                                <strong>Validações e Regras de Importação de Títulos:</strong>
                                <List bordered size="sm" style={{ marginTop: 8, wordBreak: "break-word" }} >
                                    <List.Item>
                                        São considerados títulos a partir da <strong>linha 3</strong> da planilha (Excel).
                                    </List.Item>
                                    <List.Item>
                                        Para títulos com <strong>rateio</strong>, a coluna <strong>AG (ID)</strong> deve estar preenchida e
                                        deve haver o respectivo valor na coluna <strong>AF (Valor a classificar)</strong>.
                                    </List.Item>
                                    <List.Item>
                                        Se o <strong>credor/devedor</strong> não estiver cadastrado no Omie, a importação do título será
                                        <strong> impedida</strong>.
                                    </List.Item>
                                    <List.Item>
                                        Qualquer <strong>de-para</strong> não cadastrado resultará em <strong>erro</strong> e a importação
                                        não seguirá. <em>Exceção:</em> <strong>Projetos</strong> serão cadastrados automaticamente caso o
                                        respectivo de-para não seja encontrado.
                                    </List.Item>
                                    <List.Item>
                                        Caso o campo <strong>Documento hábil</strong> na planilha esteja vazio, o tipo de documento
                                        <strong> "Outros"</strong> será considerado automaticamente.
                                    </List.Item>
                                    <List.Item>
                                        Para títulos cuja forma de pagamento seja <strong>Boleto</strong>, o <strong>código de barras</strong> deve ser um código válido para que a importação seja concluída.
                                    </List.Item>
                                    <List.Item>
                                        Para títulos com forma de pagamento <strong>PIX</strong>, a <strong>chave PIX</strong> deve já estar cadastrada no Cadastro do Cliente/Fornecedor para que a importação seja concluída com sucesso.
                                    </List.Item>
                                </List>
                            </Message>
                        </Panel>

                        {/* <Message type="success" showIcon>
                            Dica: valide uma amostra da planilha antes de importar tudo. Isso ajuda a identificar eventuais
                            mapeamentos e cadastros faltantes (de-para, credor/devedor, etc.).
                        </Message> */}
                    </div>
                </Modal.Body>

                <Modal.Footer
                    style={{
                        margin: '1rem'
                    }}
                >
                    <Button onClick={onClose} appearance="primary">
                        Entendi
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
